export default __webpack_public_path__ + "static/media/awake.a03b5c82.mp3";